import React from 'react'

export function IconBuildingLibrarySvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
      <path
        d="M9.65338 1.97997C9.86332 1.84001 10.1368 1.84001 10.3468 1.97997L17.8468 6.97997C18.134 7.17144 18.2116 7.55948 18.0201 7.84669C17.8286 8.13389 17.4406 8.2115 17.1534 8.02003L10.0001 3.25116L2.84675 8.02003C2.55955 8.2115 2.17151 8.13389 1.98003 7.84669C1.78856 7.55948 1.86617 7.17144 2.15338 6.97997L9.65338 1.97997Z"
        fill="#896145"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.875 8.61042V16.875H17.5C17.8452 16.875 18.125 17.1548 18.125 17.5C18.125 17.8452 17.8452 18.125 17.5 18.125H2.5C2.15482 18.125 1.875 17.8452 1.875 17.5C1.875 17.1548 2.15482 16.875 2.5 16.875H3.125V8.61042C3.125 8.30264 3.34906 8.04068 3.65312 7.99297C5.72148 7.66843 7.84128 7.5 10 7.5C12.1587 7.5 14.2785 7.66843 16.3469 7.99297C16.6509 8.04068 16.875 8.30264 16.875 8.61042ZM10.625 10.625C10.625 10.2798 10.3452 10 10 10C9.65482 10 9.375 10.2798 9.375 10.625V16.25C9.375 16.5952 9.65482 16.875 10 16.875C10.3452 16.875 10.625 16.5952 10.625 16.25V10.625ZM13.125 10C13.4702 10 13.75 10.2798 13.75 10.625V16.25C13.75 16.5952 13.4702 16.875 13.125 16.875C12.7798 16.875 12.5 16.5952 12.5 16.25V10.625C12.5 10.2798 12.7798 10 13.125 10ZM7.5 10.625C7.5 10.2798 7.22018 10 6.875 10C6.52982 10 6.25 10.2798 6.25 10.625V16.25C6.25 16.5952 6.52982 16.875 6.875 16.875C7.22018 16.875 7.5 16.5952 7.5 16.25V10.625Z"
        fill="#896145"
      />
      <path
        d="M10 6.5625C10.5178 6.5625 10.9375 6.14277 10.9375 5.625C10.9375 5.10723 10.5178 4.6875 10 4.6875C9.48223 4.6875 9.0625 5.10723 9.0625 5.625C9.0625 6.14277 9.48223 6.5625 10 6.5625Z"
        fill="#896145"
      />
    </svg>
  )
}
